import { LeadFormData } from 'pages/LeadForm/schema'
import { leadMortgage } from 'services/LeadMortgage'
import { mapLeadFormToMortgageData } from 'services/LeadMortgage/mapper'

import { useMutation } from '@tanstack/react-query'

export const useLeadMortgage = () =>
  useMutation({
    mutationFn: (data: LeadFormData) => leadMortgage(mapLeadFormToMortgageData(data)),
  })
